import { render, staticRenderFns } from "./GroupsTab.vue?vue&type=template&id=145245d2&scoped=true"
import script from "./GroupsTab.ts?vue&type=script&lang=ts&external"
export * from "./GroupsTab.ts?vue&type=script&lang=ts&external"
import style0 from "./GroupsTab.vue?vue&type=style&index=0&id=145245d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145245d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('145245d2')) {
      api.createRecord('145245d2', component.options)
    } else {
      api.reload('145245d2', component.options)
    }
    module.hot.accept("./GroupsTab.vue?vue&type=template&id=145245d2&scoped=true", function () {
      api.rerender('145245d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UsersManager/components/tabs/GroupsTab/GroupsTab.vue"
export default component.exports